import { useState } from "react";
import { useLang } from "../../i18n/LanguageContext";

export default function WhatsAppButton() {
  const { t } = useLang();
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip bubble */}
      {hovered && (
        <div className="bg-[#1A1A1C] border border-white/10 rounded-xl px-4 py-3 shadow-xl animate-fade-in text-right min-w-[160px]">
          <div className="text-white font-black text-xs">{t.whatsapp.label}</div>
          <div className="text-zinc-400 text-[10px]">{t.whatsapp.tooltip}</div>
        </div>
      )}

      {/* Phone button */}
      <a href="tel:01112073337"
        className="w-12 h-12 bg-[#F28C18] text-black rounded-full flex items-center justify-center text-lg shadow-2xl hover:scale-110 transition-all duration-300 relative"
        title="Call Now">
        <i className="fas fa-phone-alt" />
        <span className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" />
        </span>
      </a>

      {/* WhatsApp button */}
      <a href="https://wa.me/201112073337" target="_blank" rel="noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center text-2xl shadow-2xl hover:scale-110 hover:rotate-6 transition-all duration-300"
        title={t.whatsapp.tooltip}>
        <i className="fab fa-whatsapp" />
      </a>
    </div>
  );
}
